<template>
  <div class="wt2-full-preview">
    <preview-maker
      :story="story"
      ref="previewMaker"
      :closeModal="closeModal"
      :showGeneratedLink="showGeneratedLink"
      :previewVideoUrl="previewVideoUrl"
      :fullPreviewJob="fullPreviewJob"
      :valid.sync="previewMakerOk"
      :screenshot.sync="screenshot"
    />

    <div class="-full-preview-footer">
      <share-page-dropdown
        v-if="!isEmbedded"
        :story="story"
        :showGeneratedLink="showGeneratedLink"
        :previewVideoUrl="previewVideoUrl"
        @pause-playing="onPausePlaying"
        :style="{ visibility: !canProduce ? 'hidden' : 'visible' }"
      />

      <div class="-spring" />

      <div class="-actions" v-tab-guard>
        <wt-button
          type="transparent"
          class="-min-width-unset"
          tabindex="0"
          :text="'fullPreview.CANCEL_BUTTON' | culture"
          @click="closeModal"
        />
        <wt-button
          type="primary"
          tabindex="-1"
          :disabled="!canProduce"
          :text="'fullPreview.PRODUCE_BUTTON' | culture"
          @click="produce"
        />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import previewMaker from './PreviewMaker.vue';
import SharePageDropdown from './sharePageDropdown.vue';

export default {
  name: 'storyboard-full-preview',

  components: {
    previewMaker,
    SharePageDropdown,
  },

  props: {
    story: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },

  data() {
    return {
      screenshot: { image: null, time: null },
      previewVideoUrl: '',
      fullPreviewJob: null,
      showGeneratedLink: false,
      previewMakerOk: false,
      isEmbedded: app.isEmbedded,
    };
  },

  computed: {
    canProduce() {
      return this.previewMakerOk;
    },
  },

  beforeDestroy() {
    if (this.fullPreviewJob) {
      this.fullPreviewJob.stopListening();
    }
  },

  created() {
    this.previewVideoUrl = this.story.get('_previewVideoUrl') || '';
    this.fullPreviewJob = app.api.fullPreview.checkout(
      this.story,
      this.previewVideoUrl
    );

    this.fullPreviewJob.execution.done(() => {
      this.showGeneratedLink = true;
    });
    this.fullPreviewJob.on('change:cdnUrl', (job, value) => {
      this.fullPreviewJob.off('change:cdnUrl');
      this.previewVideoUrl = value;
    });
  },

  methods: {
    produce() {
      if (this.canProduce) {
        app.api.fullPreview.remove();
        this.closeModal({
          produce: true,
          snapshotTime: this.screenshot.time,
        });
      }
    },

    onPausePlaying() {
      this.$refs.previewMaker.onPausePlaying();
    },
  },
};
</script>
